var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    { staticClass: "card-wrapper", attrs: { href: _vm.item.url } },
    [
      _c(
        "div",
        {
          staticClass: "product-card",
          class: [{ discounted: _vm.item.product.compare_at_price }]
        },
        [
          _c("h3", {
            domProps: { innerHTML: _vm._s(_vm.item.metafields.designer) }
          }),
          _vm._v(" "),
          _c("h4", {
            staticClass: "title",
            domProps: { innerHTML: _vm._s(_vm.item.product.title) }
          }),
          _vm._v(" "),
          _c("div", { ref: "cardImage", staticClass: "img-wrapper" }, [
            _vm.mounted
              ? _c("img", {
                  ref: "img",
                  staticClass: "featured lazyload",
                  attrs: { "data-src": _vm.item.metafields.image_primary }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.mounted
              ? _c("img", {
                  staticClass: "hover lazyload",
                  attrs: { "data-src": _vm.item.metafields.image_secondary }
                })
              : _vm._e()
          ]),
          _vm._v(" "),
          _vm.showPrice
            ? _c("div", { staticClass: "price-wrapper" }, [
                _vm.item.product.compare_at_price
                  ? _c("p", { staticClass: "price-before" }, [
                      _vm._v(
                        "\n\t\t\t\t" +
                          _vm._s(
                            _vm.$formatMoney(_vm.item.product.compare_at_price)
                          ) +
                          "\n\t\t\t"
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "p",
                  {
                    class: [
                      "price",
                      { discounted: _vm.item.product.compare_at_price }
                    ]
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t" +
                        _vm._s(_vm.$formatMoney(_vm.item.product.price)) +
                        "\n\t\t\t"
                    )
                  ]
                )
              ])
            : _vm._e()
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }